export enum TeamType {
  Store = "store",
  FulfillmentService = "3PL",
}

/** A 3PL fulfills and processes on behalf of other merchants' accounts. */
export function isThirdPartyLogistics(
  team: { teamType?: TeamType | null } | undefined | null,
): boolean {
  return team?.teamType === TeamType.FulfillmentService;
}
